module.exports = __webpack_public_path__ + "img/pdf.f0fddf72.svg";